import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const breadcrumbsStatic = [{
	name: 'Locations',
	url: '/locations',
	icon: 'building',
}];

export default class Location extends Framework.Components.View {

	render() {
		let {history, location} = this.props;
		let locationName = null;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: location,
				url: `/locations/${location}`,
				icon: 'user',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Bound Books"/>
					<Tab label="Downloads"/>
					<Tab label="Details"/>
					<Tab label="FFL License"/>
					<Tab label="Add-ons"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 0})}>
				  <Collections.BoundBooks
						id={location}
						history={history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						baseUrl={this.props.baseUrl}
					/>
				</div>

			</div>
		)
	}
};